export const toLowerCase = <T extends string>(str: T) => str.toLowerCase() as Lowercase<T>;

export const toUpperCase = <T extends string>(str: T) => str.toUpperCase() as Uppercase<T>;

export const isEmptyOrUndefined = (value: string | number | undefined | null) => value === '' || value === undefined || value === null;
